export default function reducer(state = {
  list: {},
  page: {},
  fetching: false,
  fetched: false
}, action) {
  switch (action.type) {
    case 'GET_PAGE_CONTENT_PENDING': {
      return {
        ...state,
        list: {},
        page: {},
        fetching: true,
        fetched: false
      };
    }
    case 'GET_PAGE_CONTENT_FULFILLED': {
      const newList = {};
      action.payLoad.meta.contents.forEach((curr) => {
        newList[curr.identifier] = curr;
      });
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: newList,
        page: action.payLoad.data
      };
    }
    case 'GET_PAGE_CONTENT_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
  }

  return {...state};
}
